/* Jonas' Kitchen — theme.js */

/* ── Cart badge refresh ── */
function jkRefreshCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var badge = document.getElementById('jk-cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    })
    .catch(function () {});
}

/* ── Quick-add from meal tiles / cards ── */
function jkQuickAdd(btn) {
  var vid = btn.getAttribute('data-vid');
  if (!vid || btn.classList.contains('loading')) return;
  btn.classList.add('loading');
  btn.textContent = '…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.classList.remove('loading');
      btn.classList.add('added');
      btn.textContent = '✓ Added';
      jkRefreshCartCount();
      setTimeout(function () {
        btn.classList.remove('added');
        btn.textContent = '+ Add';
      }, 2400);
    })
    .catch(function () {
      btn.classList.remove('loading');
      btn.textContent = '! Retry';
      setTimeout(function () { btn.textContent = '+ Add'; }, 1800);
    });
}

/* ── Salad upsell modal (opened from plan CTAs) ──
   openUpsell(planName, planPrice, continueUrl):
   shows the modal; customer may pick one deli salad.
   closeUpsell(true) adds the selected salad to the cart
   via AJAX, then navigates to continueUrl either way. */
var jkSelectedSaladVid = null;
var jkUpsellContinueUrl = null;

function openUpsell(planName, planPrice, continueUrl) {
  var overlay = document.getElementById('jk-upsell-overlay');
  if (!overlay) { if (continueUrl) window.location.href = continueUrl; return; }
  var nameEl = document.getElementById('upsell-plan-name');
  var priceEl = document.getElementById('upsell-plan-price');
  if (nameEl) nameEl.textContent = planName;
  if (priceEl) priceEl.textContent = planPrice;
  jkSelectedSaladVid = null;
  jkUpsellContinueUrl = continueUrl || null;
  document.querySelectorAll('.salad-option').forEach(function (el) {
    el.style.borderColor = 'var(--cream-dark)';
    el.style.background = 'var(--white)';
  });
  document.querySelectorAll('.salad-check').forEach(function (el) { el.style.display = 'none'; });
  var addBtn = document.getElementById('upsell-add-btn');
  if (addBtn) addBtn.style.display = 'none';
  overlay.style.display = 'flex';
}

function selectSalad(el, vid) {
  jkSelectedSaladVid = vid;
  document.querySelectorAll('.salad-option').forEach(function (opt) {
    var check = opt.querySelector('.salad-check');
    if (opt === el) {
      opt.style.borderColor = 'var(--orange)';
      opt.style.background = '#fff9f6';
      if (check) check.style.display = 'block';
    } else {
      opt.style.borderColor = 'var(--cream-dark)';
      opt.style.background = 'var(--white)';
      if (check) check.style.display = 'none';
    }
  });
  var addBtn = document.getElementById('upsell-add-btn');
  if (addBtn) addBtn.style.display = 'block';
}

function closeUpsell(withSalad) {
  var overlay = document.getElementById('jk-upsell-overlay');
  if (overlay) overlay.style.display = 'none';
  var go = function () {
    if (jkUpsellContinueUrl) window.location.href = jkUpsellContinueUrl;
  };
  if (withSalad && jkSelectedSaladVid) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: jkSelectedSaladVid, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        jkRefreshCartCount();
        var toast = document.getElementById('jk-toast');
        if (toast) {
          toast.style.display = 'block';
          setTimeout(function () { toast.style.display = 'none'; }, 2500);
        }
        setTimeout(go, 900);
      })
      .catch(go);
  } else {
    go();
  }
}

/* ── Mobile nav toggle ── */
function jkToggleNav() {
  var nav = document.getElementById('jk-mobile-nav');
  var btn = document.getElementById('jk-nav-toggle');
  if (!nav || !btn) return;
  var open = nav.classList.toggle('open');
  btn.classList.toggle('open', open);
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  nav.setAttribute('aria-hidden', open ? 'false' : 'true');
}

/* ── Wiring ── */
document.addEventListener('DOMContentLoaded', function () {
  var upsellOverlay = document.getElementById('jk-upsell-overlay');
  if (upsellOverlay) {
    upsellOverlay.addEventListener('click', function (e) {
      if (e.target === this) closeUpsell(false);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeUpsell(false);
  });
});
